import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import moment from 'moment/moment';
import { toast } from 'react-toastify';
import { FiEdit } from "react-icons/fi";
import { useSelector } from 'react-redux';
import { MdDelete } from "react-icons/md";
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import { RiRefreshLine } from "react-icons/ri";
import PersonalDetails from "./customermodal";
import { IoIosArrowForward } from "react-icons/io";
import "react-datepicker/dist/react-datepicker.css";
import { FaSave, FaChevronLeft } from "react-icons/fa";
import LeaseApiService from '../../services/apiService';
import { useLocation, useNavigate } from 'react-router-dom';
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { getCompany, getName } from '../../../Redux/selecters';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { AsyncPaginate } from 'react-select-async-paginate';
import { MdAdd } from "react-icons/md";
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';

const LeaseReservationCreateByBashboard = () => {
    let navigate = useNavigate()
    const ITEMS_PER_PAGE = 100
    const currentdate = new Date();
    const location = useLocation();
    const leaseData = location.state;
    const userName = useSelector(getName);
    const apiService = new LeaseApiService();
    const companies = useSelector(getCompany);
    const [leaseda, setLeaseDat] = useState();
    const { currencyPrecision } = useCurrency();
    const [datamsg, etdatamessage] = useState();
    const onOpenModal = () => setmsgModal(true);
    const [loading, setloader] = useState(false);
    const [TypeList, setTypeList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const onCloseModal = () => setmsgModal(false);
    const [activeTab, setActiveTab] = useState(0);
    const [barload, setBarLoad] = useState(false);
    const [AgentList, setAgentList] = useState([]);
    const [AgentTab, setAgentTab] = useState(true);
    const [unitRent, setUnitRent] = useState(true);
    const [msgModal, setmsgModal] = useState(false);
    const [FilterTab, setFilterTab] = useState(true);
    const [tanentList, setTanentList] = useState([]);
    const [BrokerList, setBrokerList] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [ManagerList, setManagerList] = useState([]);
    const [PackageList, setPackageList] = useState([]);
    const [remarksList, setRemarksList] = useState([]);
    const [propertyList, setPropertyList] = useState([]);
    const [SecondaryTab, setSecondaryTab] = useState(true);
    const [datesEditable, setDatesEditable] = useState(false);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);

    // Customer

    const [popActive, setPopActive] = useState(0);
    const [tenantModal, setTenantModal] = useState(false);
    const [popVisibility, setPopVisibility] = useState([true, false]);
    const [sourceList, setSourceList] = useState([]);
    const [customerTypeList, setCustomerTypeList] = useState([]);
    const [salesPersonList, setSalesPersonList] = useState([]);
    const [leadStatus, setLeadStatus] = useState([]);
    const [packageName, setPackageName] = useState([]);
    const [titleList, setTitleList] = useState([]);
    const [personalTabLeadType, setPersonalTabLeadType] = useState([]);
    const [categoryMix, setCategoryMix] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [countriesList, setCountries] = useState([]);
    const [nationalityList, setNationalitylist] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [agentList, setagentList] = useState([]);
    const currencyList = JSON.parse(localStorage.getItem('currencylist')) || [];
    const defaultCountry = currencyPrecision?.code ? getCountryFromCurrency(currencyPrecision?.code, currencyList) : 'bh'; // fallback until API loads

    useEffect(() => {
        SetLeaseData()
        fetchDropdownData();
        fetchDropdown();
    }, []);
    useEffect(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
        setFormData((prev) => ({ ...prev, transDate: formattedDate }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'CustSource,SalesPersons,CustomerType,CustTitles,CustAgents,CustPackageNames,PersonalTabLeadType');
            const res = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params.toString()}`);
            setSourceList(res?.data?.dropdowns?.CustSource)
            setCustomerTypeList(res?.data?.dropdowns?.CustomerType)
            setSalesPersonList(res?.data?.dropdowns?.SalesPersons)
            setagentList(res?.data?.dropdowns?.Agents)
            setPackageName(res?.data?.dropdowns?.CustPackageNames)
            setTitleList(res?.data?.dropdowns?.CustTitles)
            setPersonalTabLeadType(res?.data?.dropdowns?.PersonalTabLeadType)
            setLeadStatus([{ value: 'All', text: 'All' }, { value: 'Open', text: 'Open' }, { value: 'In Process', text: 'In Process' }, { value: 'Closed', text: 'Closed' }]);
            setTransectionData({
                ...transectionData,
                type: { label: "Individual", value: res?.data?.dropdowns?.CustomerType[0] },
            });
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const fetchDropdown = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'CategoryMix,Nationality,Country');
            const res = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params.toString()}`);
            setCategoryMix(res?.data?.dropdowns?.CategoryMix)
            setCountries(res?.data?.dropdowns?.Country)
            setNationalitylist(res?.data?.dropdowns?.Nationality)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    }
    const calculateDaysBetween = (from, to) => {
        const diff = new Date(to) - new Date(from);
        let leaseDate = Math.ceil(diff / (1000 * 60 * 60 * 24))
        return leaseDate + 1;
    }
    const SetLeaseData = async () => {
        if (leaseData) {
            setBarLoad(true)
            const today = new Date();
            const formatted = formatDate(today); // 'DD-MMM-YYYY'
            setDatesEditable(false);

            // drpopDownApi list
            const dropparams = new URLSearchParams();
            dropparams.append('dropdownTypes', 'ReservationProductNames,ReservationTenantNames,ReservationPropertyNames,ReservationSalesPersons,ReservationAgents,ReservationLeaseRemarks,ReservationPropetyManagerNames,ReservationTypes');
            const customerRes = await apiService.getApiParamater('GET_MULTI_DROP_RESERV', `?${dropparams.toString()}`);
            let DB = localStorage.getItem('DataBase')
            let selectCompany = companies?.companies.find((comp) => comp.dataDB === DB)
            const selectedManager = customerRes?.data?.dropdowns?.PropetyManagerNames?.filter(pro => pro?.value === selectCompany?.companyNo);
            setTypeList(customerRes?.data?.dropdowns?.ReservationTypes);
            setPackageList(customerRes?.data?.dropdowns?.ProductNames);
            setBrokerList(customerRes?.data?.dropdowns?.Agents);
            setManagerList(selectedManager);
            setAgentList(customerRes?.data?.dropdowns?.SalesPersons);
            setTanentList(customerRes?.data?.dropdowns?.TenantNames);
            setRemarksList(customerRes?.data?.dropdowns?.LeaseRemarks);
            setPropertyList(customerRes?.data?.dropdowns?.PropertyNames);
            let leaserec = leaseData
            // Api Call for Customer1
            setLeaseDat(leaseData)
            let selectedProperty = customerRes?.data?.dropdowns?.PropertyNames.find(
                (comp) =>
                    comp.text?.toLowerCase() === leaserec?.propertyName?.toLowerCase()
            );
            const params = new URLSearchParams();
            params.append('Action', 'GetUnitDetailsByPropNoAndUnitNo');
            params.append('UnitNo', leaserec?.unitNo);
            params.append('PropertyNo', selectedProperty?.value);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let data = res?.data?.result?.data
            let rentPerMonth = data?.Rent_Per_Annum / 12
            const Amountparams = new URLSearchParams();
            Amountparams.append('Action', tenantDetails?.tanent1Code?.value?.Category_Mix === "US Navy" ? 'CalculateRentByMonthUSNAVY' : 'CalculateRentByMonth');
            Amountparams.append('PeriodFrom', moment(formatted).format("DD-MMM-YYYY"));
            Amountparams.append('PeriodTo', moment(formatted).format("DD-MMM-YYYY"));
            Amountparams.append('Commontext', rentPerMonth);
            const AmountRes = await apiService.getApiParamater('GET_RESERV_COMMON', `?${Amountparams.toString()}`);
            let result = AmountRes?.data?.result?.data?.RentPerAnnum
            let rentPerDay = result / 360
            let deposit = data?.Security_Deposit
            setFormData({
                ...formData,
                Property: { label: selectedProperty?.text, value: selectedProperty?.value },
                Unit: { label: leaserec?.unitNo, value: leaserec?.unitNo },
                All_In_Rent: data?.All_In_Rent,
                Bedrooms: data?.Bedrooms,
                Floor: data?.Floor,
                Installments: data?.Installments,
                LLEMailID: data?.LLEMailID,
                Landlord: data?.Landlord,
                MuncAcNo: data?.MuncAcNo,
                PEmail: data?.PEmail,
                Parking: data?.Parking,
                Parking_Price: data?.Parking_Price,
                Ref_No: data?.Ref_No,
                Rent_Per_Annum: data?.Rent_Per_Annum,
                Rent_Per_period: parseFloat(result),
                Rent_Per_Day: rentPerDay || 0,
                Rent_Month: rentPerMonth,
                Rent_Per_Month: rentPerMonth?.toFixed(currencyPrecision?.decimalNumbers),
                Security_Deposit:
                    Number(data?.Security_Deposit) > 0
                        ? Number(data.Security_Deposit).toFixed(currencyPrecision?.decimalNumbers)
                        : Number(rentPerMonth).toFixed(currencyPrecision?.decimalNumbers),
                Tenant_Commission: data?.Tenant_Commission,
                Total_Area: data?.Total_Area,
                Unit_Class: data?.Unit_Class,
                transDate: formatted,
                periodFrom: formatted,
                periodto: formatted,
                leaseTerm: '1',
            });
            if (result) {
                advanceRentCalculation({ rentPerMonth }, result)
            }
            setBarLoad(false)
        }
    }
    const [entries, setEntries] = useState([{
        Property: [],
        Unit: [],
        reservation: [],
        remarks1: '',
        remarks2: '',
        Unit: '',
        All_In_Rent: '',
        Bedrooms: '',
        Floor: '',
        Installments: '',
        LLEMailID: '',
        Landlord: '',
        MuncAcNo: '',
        PEmail: '',
        Parking: '',
        Parking_Price: '',
        Ref_No: '',
        Rent_Per_Annum: '',
        Rent_Per_period: '',
        Rent_Per_Month: '',
        Rent_Per_Day: '',
        Security_Deposit: '',
        Tenant_Commission: '',
        Total_Area: '',
        Unit_Class: '',
        leaseTerm: '',
        transDate: '',
        periodto: '',
        periodFrom: '',
        leaseFee: '',
        advanceRent: "",
        electricty: '',
        term: '',
        month: '',
        days: '',
        rentFree: '',
        filter: '',
        serviceCharges: '',
    }]);
    // Tenant Details where tenant and agents, Broker details stored
    const [tenantDetails, setTenantDetails] = useState({
        tanent1: [],
        tanent1Code: [],
        tanent2: [],
        tanent2Code: [],
        agent: [],
        prpManager: [],
        broker: [],
        package: [],
        type: [],
    });
    // FormData  where Property and Unit  details stored
    const [formData, setFormData] = useState({
        Property: [],
        Unit: [],
        reservation: [],
        remarks1: '',
        remarks2: '',
        Unit: '',
        electrictType: '',
        internet: false,
        All_In_Rent: '',
        Bedrooms: '',
        Floor: '',
        Installments: '',
        LLEMailID: '',
        Landlord: '',
        MuncAcNo: '',
        PEmail: '',
        Parking: '',
        Parking_Price: '',
        Ref_No: '',
        Rent_Per_Annum: '',
        Rent_Per_period: '',
        Rent_Per_Month: '',
        Rent_Per_Day: '',
        Security_Deposit: '',
        Tenant_Commission: '',
        Total_Area: '',
        Unit_Class: '',
        leaseTerm: '1',
        transDate: '',
        periodto: '',
        periodFrom: '',
        leaseFee: '',
        advanceRent: 0,
        electricty: '',
        term: '',
        month: 2,
        days: '',
        rentFree: '',
        filter: '',
        serviceCharges: '',
    });

    const [transectionData, setTransectionData] = useState({
        salesPerson: '',
        type: '',
        mobileNo: '',
        agent: '',
        fullName: '',
        title: '',
        email: '',
        firstName: '',
        gender: '',
        lastName: '',
        phoneNo: '',
        poBox: '',
        categoryMix: '',
        salesPerson: '',
        address: '',
        dateofBirth: '',
        firstNameAR: '',
        lastNameAR: '',
        addressAR: '',
        source: '',
        designatoin: '',
        subsource: '',
        leadtype: '',
        countryCode: '',
        companyName: '',
        designation: '',
        nationality: null,
        productType: null,
    });

    const validationRules = [
        { key: "type", message: "Please Select Type from Personal Details" },
        { key: "title", message: "Please Select Title from Personal Details" },
        { key: "firstName", message: "Please Enter FullName" },
        { key: "mobileNo", message: "Please Enter Mobile No" },
        { key: "email", message: "Please Enter Email" },
        { key: "leadtype", message: "Please Enter Lead Type" },
        { key: "nationality", message: "Please Enter Nationality" },
        { key: "source", message: "Please Enter Source" },
        // { key: "subsource", message: "Please Enter Sub Source" },
        { key: "salesPerson", message: "Please Enter Sales Person" },
        // { key: "dateofBirth", message: "Please Enter Date Of Birth" },
    ];

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handlePopClick = (tabIndex) => {
        setPopActive(tabIndex);
        const newGridVisibility = popVisibility.map((_, index) => index === tabIndex);
        setPopVisibility(newGridVisibility);
    };
    // Customer Change function where store selected customer in TenantDetails State
    const handleCust1Change = async (selectedOption) => {
        if (tenantDetails?.tanent2?.label === selectedOption?.label) {
            toast?.warning(`Primary Tanent Should be Different from Secondary Tanent `)
            return;
        }
        else {
            setTenantDetails({
                ...tenantDetails,
                agent: { label: null, value: null },
                broker: { label: null, value: null },
            });
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.value);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let data = res?.data?.result?.data
            const selectedBroker = BrokerList?.find(pro => pro?.text === data?.Agent);
            const selectedAgent = AgentList?.find(pro => pro?.text === data?.SalesPerson);
            setTenantDetails({
                ...tenantDetails,
                tanent1: selectedOption,
                tanent1Code: { label: selectedOption?.value, value: data },
                agent: { label: selectedAgent?.text || "", value: selectedAgent?.value || "" },
                broker: { label: selectedBroker?.text || "", value: selectedBroker?.value || "" },
            });
        }
    }
    const handleCust1CodeChange = async (selectedOption) => {
        if (tenantDetails?.tanent2Code?.label === selectedOption?.label) {
            toast?.warning(`Primary Tanent Should be Different from Secondary Tanent `)
            return;
        }
        else {
            setTenantDetails({
                ...tenantDetails,
                agent: { label: null, value: null },
                broker: { label: null, value: null },
            });
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.label);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let data = res?.data?.result?.data
            const selectedBroker = BrokerList?.find(pro => pro?.text === data?.Agent);
            const selectedAgent = AgentList?.find(pro => pro?.text === data?.SalesPerson);

            setTenantDetails({
                ...tenantDetails,
                tanent1: { label: selectedOption?.value, value: selectedOption?.label },
                tanent1Code: { label: selectedOption?.label, value: res?.data?.result?.data },
                agent: { label: selectedAgent?.text || "", value: selectedAgent?.value || "" },
                broker: { label: selectedBroker?.text || "", value: selectedBroker?.value || "" },
            });
        }
    }
    // Joint Customer Change function where store selected customer in TenantDetails State
    const handleCust2Change = async (selectedOption) => {
        if (tenantDetails?.tanent1?.label === selectedOption?.label) {
            toast?.warning(`Secondary Tanent Should be Different from Primary Tanent `)
            return;
        }
        else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.value);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            setTenantDetails({
                ...tenantDetails,
                tanent2: selectedOption,
                tanent2Code: { label: selectedOption?.value, value: res?.data?.result?.data },
            });
        }
    }
    const handleCust2CodeChange = async (selectedOption) => {
        if (tenantDetails?.tanent1Code?.label === selectedOption?.label) {
            toast?.warning(`Secondary Tanent Should be Different from Primary Tanent `)
            return;
        }
        else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.label);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            setTenantDetails({
                ...tenantDetails,
                tanent2: { label: selectedOption?.value, value: selectedOption?.label },
                tanent2Code: { label: selectedOption?.label, value: res?.data?.result?.data },
            });
        }
    }
    // Agent Change function where store selected Agent in TenantDetails State
    const handleAgentChange = (selectedOption) => {
        setTenantDetails({ ...tenantDetails, agent: selectedOption });
    }
    // Property Manager Change function where store selected Property Manager in TenantDetails State
    const handleManagerChange = (selectedOption) => {
        setTenantDetails({ ...tenantDetails, prpManager: selectedOption });
    }
    // Broker Change function where store selected Broker in TenantDetails State
    const handleBrokerChange = (selectedOption) => {
        setTenantDetails({ ...tenantDetails, broker: selectedOption });
    }
    // Package Change function where store selected Package in TenantDetails State
    const handlePackageChange = (selectedOption) => {
        setTenantDetails({ ...tenantDetails, package: selectedOption });
    }
    // Tenant Type Change function where store selected Tenant Type  in TenantDetails State
    const handleTypeChange = (selectedOption) => {
        setTenantDetails({ ...tenantDetails, type: selectedOption });
    }
    const getMonthDiff = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);

        if (endDate < startDate) return 0;

        // Calculate month difference
        let months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
        months += endDate.getMonth() - startDate.getMonth();

        // Include last month if end day >= start day
        if (endDate.getDate() >= startDate.getDate()) {
            months += 1;
        }

        return months;
    };
    // unit funtions
    // Handle change function where i store unit details that entered  in input fields of unit  
    const handleChange = async (e) => {
        const { name, value } = e.target;

        if (name === 'Rent_Per_Month') {

            const enteredValue = Number(value || 0);
            const minRent = Number(formData?.Rent_Month || 0);

            // // Prevent less than minimum value
            // if (enteredValue < minRent) {
            //     toast?.warning(`Rent must be greater than or equal to ${minRent}`);

            //     setFormData((prev) => ({
            //         ...prev,
            //         [name]: minRent,
            //     }));

            //     return;
            // }

            setFormData((prev) => ({
                ...prev,
                [name]: enteredValue,
            }));

            const params = new URLSearchParams();
            params.append('Action', tenantDetails?.tanent1Code?.value?.Category_Mix === "US Navy" ? 'CalculateRentByMonthUSNAVY' : 'CalculateRentByMonth');
            params.append('PeriodFrom', formData?.periodFrom);
            params.append('PeriodTo', formData?.periodto);
            params.append('Commontext', enteredValue);

            const res = await apiService.getApiParamater(
                'GET_RESERV_COMMON',
                `?${params.toString()}`
            );

            let result = res?.data?.result?.data?.RentPerAnnum;

            if (result) {
                advanceRentCalculation({ perMonthval: enteredValue });

                setFormData((prev) => ({
                    ...prev,
                    Rent_Per_period: result || 0,
                    Security_Deposit: enteredValue?.toFixed(currencyPrecision?.decimalNumbers) || 0,
                }));
            }

        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    };
    // Addmore function that use for store selected unit and data entered in formData
    const handleAddMore = async () => {
        const enteredValue = Number(formData?.Rent_Per_Month || 0);
        const minRent = Number(formData?.Rent_Month || 0);
        if (!formData.Property?.label) {
            toast.warning(`Please Select Property`);
            return;
        } else if (!formData.Unit?.label) {
            toast.warning(`Please Select Unit No`);
            return;
        } else if (!formData?.term) {
            toast.warning(`Please select any Lease Term`);
            return;
        } else if (!formData?.periodFrom) {
            toast.warning(`Please select Period From`);
            return;
        } else if (!formData?.periodto) {
            toast.warning(`Please select Period to`);
            return;
        } else if (!formData?.Rent_Per_period) {
            toast.warning(`Please Enter Rent Per Period amount`);
            return;
        } else if (!formData?.Rent_Per_Annum) {
            toast.warning(`Please Enter Rent Per Annum amount`);
            return;
        } else if (!formData?.Unit_Class) {
            toast.warning(`Unit class is unavailable please select another Unit`);
            return;
        } else if (enteredValue < minRent) {
            toast?.warning(`Rent must be greater than or equal to ${minRent}`);
            return;
        }

        const isLease = formData.Unit_Class === 'Lease';
        const isPM = formData.Unit_Class === 'PM';
        const leaseCount = entries.filter(e => e.Unit_Class === 'Lease').length;
        const pmCount = entries.filter(e => e.Unit_Class === 'PM').length;

        // Rule: Do not mix PM and Lease
        if ((isLease && pmCount > 0)) {
            toast.warning(`You cannot add Lease Unit with PM Unit.`);
            return;
        }
        if ((isPM && leaseCount > 0)) {
            toast.warning(`You cannot add PM Unit with Lease Unit.`);
            return;
        }
        // // Rule: Max 2 Lease entries
        // if (isLease && leaseCount >= 2) {
        //     toast.warning(`You can only add up to 2 Lease entries.`);
        //     return;
        // }

        // Rule: Max 1 PM entry
        if (isPM && pmCount >= 1) {
            toast.warning(`You can only add 1 PM entry.`);
            return;
        }
        const checkparams = new URLSearchParams();
        checkparams.append('Action', 'CheckAddunitReservationValidation');
        checkparams.append('PropertyNo', formData.Property?.value);
        checkparams.append('UnitNo', formData.Unit?.label);
        checkparams.append('PeriodFrom', moment(formData?.periodFrom).format("DD-MMM-YYYY"));
        checkparams.append('PeriodTo', moment(formData?.periodto).format("DD-MMM-YYYY"));
        const checkResponse = await apiService.getApiParamater('GET_RESERV_COMMON', `?${checkparams.toString()}`);

        let checkResult = checkResponse?.data?.result?.data
        if (checkResult?.Cnt >= 1) {
            toast.warning(checkResult?.Msg)
            return;
        } else if (checkResult?.Cnt === 0) {
            const params = new URLSearchParams();
            params.append('Action', 'CheckbookingThroughNavyValidation');
            params.append('PropertyNo', formData.Property?.value);
            params.append('Agent', tenantDetails?.agent?.label || "");
            params.append('SalesPerson', tenantDetails?.broker?.label || "");
            params.append('Commontext', '');
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let result = res?.data?.result?.data?.Msg
            etdatamessage(result)
            if (res?.data?.result?.data?.Msg === "0") {
                dataset()
            } else {
                onOpenModal()
            }
        }
    }
    const dataset = () => {

        if (!entries[0]?.Property?.label) {
            setEntries(prevEntries => prevEntries.slice(1));
        }
        if (editIndex !== null) {
            const updatedEntries = [...entries];
            updatedEntries[editIndex] = formData;
            setEntries(updatedEntries);
            setEditIndex(null);
        } else {
            setEntries((prev) => [...prev, formData]);
        }
        // Reset form
        const today = new Date();
        const formatted = formatDate(today);
        setDatesEditable(false);

        setFormData({
            Property: [{ label: '', value: '' }],
            Unit: [{ label: '', value: '' }],
            reservation: [],
            remarks1: '',
            remarks2: '',
            All_In_Rent: '',
            Bedrooms: '',
            Floor: '',
            Installments: '',
            internet: false,
            LLEMailID: '',
            Landlord: '',
            MuncAcNo: '',
            PEmail: '',
            Parking: '',
            Parking_Price: '',
            Ref_No: '',
            Rent_Per_Annum: '',
            Rent_Per_period: '',
            Rent_Per_Month: '',
            Rent_Per_Day: '',
            Security_Deposit: '',
            Tenant_Commission: '',
            Total_Area: '',
            Unit_Class: '',
            leaseFee: '',
            advanceRent: 0,
            electricty: '',
            term: '',
            month: 2,
            days: '',
            rentFree: '',
            filter: '',
            serviceCharges: '',
            transDate: formatted,
            periodFrom: formatted,
            periodto: formatted,
            leaseTerm: '1',
        });
        onCloseModal()
    }
    const handleUpdate = async () => {
        const enteredValue = Number(formData?.Rent_Per_Month || 0);
        const minRent = Number(formData?.Rent_Month || 0);
        if (!formData.Property?.label) {
            toast.warning(`Please Select Property`);
            return;
        } else if (!formData.Unit?.label) {
            toast.warning(`Please Select Unit No`);
            return;
        } else if (!formData?.term) {
            toast.warning(`Please select any Lease Term`);
            return;
        } else if (!formData?.periodFrom) {
            toast.warning(`Please select Period From`);
            return;
        } else if (!formData?.periodto) {
            toast.warning(`Please select Period to`);
            return;
        } else if (!formData?.Rent_Per_period) {
            toast.warning(`Please Enter Rent Per Period amount`);
            return;
        } else if (!formData?.Rent_Per_Annum) {
            toast.warning(`Please Enter Rent Per Annum amount`);
            return;
        } else if (!formData?.Unit_Class) {
            toast.warning(`Unit class is unavailable please select another Unit`);
            return;
        } else if (enteredValue < minRent) {
            toast?.warning(`Rent must be greater than or equal to ${minRent}`);
            return;
        }

        const checkparams = new URLSearchParams();
        checkparams.append('Action', 'CheckUpdateunitReservationValidation');
        checkparams.append('PropertyNo', formData.Property?.value);
        checkparams.append('UnitNo', formData.Unit?.label);
        checkparams.append('PeriodFrom', moment(formData?.periodFrom).format("DD-MMM-YYYY"));
        checkparams.append('PeriodTo', moment(formData?.periodto).format("DD-MMM-YYYY"));
        const checkResponse = await apiService.getApiParamater('GET_RESERV_COMMON', `?${checkparams.toString()}`);

        let checkResult = checkResponse?.data?.result?.data
        if (checkResult?.Cnt === 0) {
            toast.warning(checkResult?.Msg)
            return;
        } else if (checkResult?.Cnt >= 1) {
            if (editIndex !== null) {
                const updatedEntries = [...entries];
                updatedEntries[editIndex] = formData;
                setEntries(updatedEntries);

                setEditIndex(null);
            } else {
                setEntries((prev) => [...prev, formData]);
            }

            // Clear form
            setFormData({
                Property: [],
                Unit: [],
                reservation: [],
                remarks1: '',
                remarks2: '',
                Unit: '',
                All_In_Rent: '',
                Bedrooms: '',
                Floor: '',
                Installments: '',
                internet: false,
                LLEMailID: '',
                Landlord: '',
                MuncAcNo: '',
                PEmail: '',
                electrictType: '',
                Parking: '',
                Parking_Price: '',
                Ref_No: '',
                Rent_Per_Annum: '',
                Rent_Per_period: '',
                Rent_Per_Month: '',
                Rent_Per_Day: '',
                Security_Deposit: '',
                Tenant_Commission: '',
                Total_Area: '',
                Unit_Class: '',
                leaseTerm: '1',
                transDate: currentdate,
                periodto: currentdate,
                periodFrom: currentdate,
                leaseFee: '',
                advanceRent: 0,
                electricty: '',
                term: '',
                month: 2,
                days: '',
                rentFree: '',
                filter: '',
                serviceCharges: '',
            });
        }
    }
    const handleEdit = (index) => {
        setFormData(entries[index]);
        setDatesEditable(true);
        setEditIndex(index);
    }
    const handleDelete = (index) => {
        const updatedEntries = entries.filter((_, i) => i !== index);
        setEntries(updatedEntries);
        if (editIndex === index) {
            setFormData({
                Property: [],
                Unit: [],
                reservation: [],
                remarks1: '',
                remarks2: '',
                Unit: '',
                All_In_Rent: '',
                Bedrooms: '',
                Floor: '',
                Installments: '',
                internet: false,
                electrictType: '',
                LLEMailID: '',
                Landlord: '',
                MuncAcNo: '',
                PEmail: '',
                Parking: '',
                Parking_Price: '',
                Ref_No: '',
                Rent_Per_Annum: '',
                Rent_Per_period: '',
                Rent_Per_Month: '',
                Rent_Per_Day: '',
                Security_Deposit: '',
                Tenant_Commission: '',
                Total_Area: '',
                Unit_Class: '',
                leaseTerm: '1',
                transDate: '',
                periodto: '',
                periodFrom: '',
                leaseFee: '',
                advanceRent: 0,
                electricty: '',
                term: '',
                month: 2,
                days: '',
                filter: '',
                rentFree: '',
                serviceCharges: '',
            });
            setEditIndex(null);
        }
    }
    const handlePropertyChange = async (selectedOption) => {
        setUnitList([])
        const params = new URLSearchParams();
        params.append('DropdownFor', 'ResvCreateUnitNosByPropertyId');
        params.append('CascadValue', selectedOption?.value);
        const res = await apiService.getApiParamater('GET_CASCAD_RESERV', `?${params.toString()}`);
        setUnitList(res?.data?.items)
        setFormData({
            Property: selectedOption,
            Unit: [{ label: '', value: '' }],
            reservation: [],
            remarks1: '',
            remarks2: '',
            Unit: '',
            All_In_Rent: '',
            Bedrooms: '',
            Floor: '',
            internet: false,
            Installments: '',
            LLEMailID: '',
            Landlord: '',
            MuncAcNo: '',
            PEmail: '',
            Parking: '',
            Parking_Price: '',
            Ref_No: '',
            electrictType: '',
            Rent_Per_Annum: '',
            Rent_Per_period: '',
            Rent_Per_Month: '',
            Rent_Per_Day: '',
            Security_Deposit: '',
            Tenant_Commission: '',
            Total_Area: '',
            Unit_Class: '',
            leaseTerm: '1',
            leaseFee: '',
            advanceRent: 0,
            electricty: '',
            term: '',
            month: 2,
            days: '',
            filter: '',
            serviceCharges: '',
            rentFree: '',
        });
    }
    const handleRemarksChange = (selectedOption) => {
        setFormData({
            ...formData,
            reservation: selectedOption,
            remarks2: selectedOption?.value?.text
        });
    }
    const handleUnitChange = async (selectedOption) => {
        // handleClearForm()
        const params = new URLSearchParams();
        params.append('Action', 'GetUnitDetailsByPropNoAndUnitNo');
        params.append('UnitNo', selectedOption?.label);
        params.append('PropertyNo', formData?.Property?.value);
        const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
        let data = res?.data?.result?.data
        let rentPerMonth = data?.Rent_Per_Annum / 12
        const Amountparams = new URLSearchParams();
        Amountparams.append('Action', tenantDetails?.tanent1Code?.value?.Category_Mix === "US Navy" ? 'CalculateRentByMonthUSNAVY' : 'CalculateRentByMonth');
        Amountparams.append('PeriodFrom', moment(formData?.periodFrom).format("DD-MMM-YYYY"));
        Amountparams.append('PeriodTo', moment(formData?.periodto).format("DD-MMM-YYYY"));
        Amountparams.append('Commontext', rentPerMonth);
        const AmountRes = await apiService.getApiParamater('GET_RESERV_COMMON', `?${Amountparams.toString()}`);
        let result = AmountRes?.data?.result?.data?.RentPerAnnum
        let rentPerDay = result / 360
        let deposit = data?.Security_Deposit
        setFormData({
            ...formData,
            Unit: selectedOption,
            All_In_Rent: data?.All_In_Rent,
            Bedrooms: data?.Bedrooms,
            Floor: data?.Floor,
            Installments: data?.Installments,
            LLEMailID: data?.LLEMailID,
            Landlord: data?.Landlord,
            MuncAcNo: data?.MuncAcNo,
            PEmail: data?.PEmail,
            Parking: data?.Parking,
            Parking_Price: data?.Parking_Price,
            Ref_No: data?.Ref_No,
            Rent_Per_Annum: data?.Rent_Per_Annum,
            Rent_Per_period: parseFloat(result),
            Rent_Per_Day: rentPerDay || 0,
            Rent_Month: rentPerMonth,
            Rent_Per_Month: rentPerMonth?.toFixed(currencyPrecision?.decimalNumbers),
            Security_Deposit:
                Number(data?.Security_Deposit) > 0
                    ? Number(data.Security_Deposit).toFixed(currencyPrecision?.decimalNumbers)
                    : Number(rentPerMonth).toFixed(currencyPrecision?.decimalNumbers),
            Tenant_Commission: data?.Tenant_Commission,
            Total_Area: data?.Total_Area,
            Unit_Class: data?.Unit_Class,
        });
        if (result) {
            advanceRentCalculation({ rentPerMonth }, result)
        }
    }
    const handleTermChange = async (e) => {
        const term = e.target.value;
        const today = new Date();
        let periodFrom = today;
        let periodTo = new Date(today);

        if (term === "Short Term") {
            periodTo.setMonth(periodTo.getMonth() + 3);
            periodTo.setDate(periodTo.getDate() - 1);
        } else if (term === "Long Term" || term === "Less than one Year") {
            periodTo.setFullYear(periodTo.getFullYear() + 1);
            periodTo.setDate(periodTo.getDate() - 1); // Subtract 1 day to make it inclusive
        }
        const formattedFrom = formatDate(periodFrom);
        const formattedTo = formatDate(periodTo);
        const leaseTerm = calculateDaysBetween(formattedFrom, formattedTo);
        const params = new URLSearchParams();
        params.append('Action', tenantDetails?.tanent1Code?.value?.Category_Mix === "US Navy" ? 'CalculateRentByMonthUSNAVY' : 'CalculateRentByMonth');
        params.append('PeriodFrom', moment(formattedFrom).format("DD-MMM-YYYY"));
        params.append('PeriodTo', moment(formattedTo).format("DD-MMM-YYYY"));
        params.append('Commontext', formData?.Rent_Per_Month);
        const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
        let result = res?.data?.result?.data?.RentPerAnnum
        const leaseTermInMonths = getMonthDiff(formattedFrom, formattedTo);
        setFormData((prev) => ({
            ...prev,
            term,
            periodFrom: formattedFrom,
            periodto: formattedTo,
            Rent_Per_period: result,
            Installments: leaseTermInMonths,
            // Rent_Per_Annum: result,
            leaseTerm: leaseTerm.toString(),
        }));
        advanceRentCalculation({ leaseTerm }, result)
        setDatesEditable(true);
    }
    const handleElectChange = async (e) => {
        const term = e.target.value;
        setFormData((prev) => ({
            ...prev,
            electrictType: term,
            internet: true,
        }));
    }
    const handleInterNetChange = async (e) => {
        setFormData((prev) => ({
            ...prev,
            internet: e,
        }));
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };

        // Only auto-set periodto when periodFrom is selected and term is specific
        if ((formData.term === "Long Term" || formData.term === "Less than one Year") && name === 'periodFrom') {
            const fromDate = moment(updatedValue, "DD-MMM-YYYY");
            const toDate = fromDate.clone().add(1, 'year').subtract(1, 'day');
            updatedDates.periodto = toDate.format("DD-MMM-YYYY");
        }

        // Grab up-to-date periodFrom and periodto
        const from = name === 'periodFrom' ? updatedValue : formData.periodFrom;
        const to = name === 'periodto' ? updatedValue : updatedDates.periodto || formData.periodto;

        // If both dates exist, validate and calculate rent
        if (from && to) {
            const fromDate = moment(from, "DD-MMM-YYYY");
            const toDate = moment(to, "DD-MMM-YYYY");

            if (fromDate.isAfter(toDate)) {
                toast?.warning('Period From date must be less than Period To date.');
                return;
            }

            const params = new URLSearchParams();
            params.append('Action', tenantDetails?.tanent1Code?.value?.Category_Mix === "US Navy" ? 'CalculateRentByMonthUSNAVY' : 'CalculateRentByMonth');
            params.append('PeriodFrom', fromDate.format("DD-MMM-YYYY"));
            params.append('PeriodTo', toDate.format("DD-MMM-YYYY"));
            params.append('Commontext', formData?.Rent_Per_Month);
            const leaseTermInMonths = getMonthDiff(fromDate, toDate);

            try {
                const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
                const result = res?.data?.result?.data?.RentPerAnnum;
                const leaseTerm = calculateDaysBetween(from, to);
                updatedDates.leaseTerm = leaseTerm.toString();
                updatedDates.Rent_Per_period = result;
                updatedDates.Installments = leaseTermInMonths;
                advanceRentCalculation({ result });
            } catch (error) {
                console.error("API call failed", error);
            }
        }

        setFormData(updatedDates);
    }
    const advanceRentCalculation = (rentPerMonths, result) => {
        setFormData((prev) => ({
            ...prev,
            advanceRent: 0,
        }));
        let rentPerMonth = rentPerMonths?.rentPerMonth ? rentPerMonths?.rentPerMonth : rentPerMonths?.perMonthval || formData?.Rent_Per_Month || 0
        let leaseTerm = rentPerMonths?.leaseTerm || formData?.leaseTerm || 0
        let rentPerPeriod = result || formData?.Rent_Per_period || 0
        const rentPerDay = parseFloat(rentPerPeriod / leaseTerm)
        let monthValue = rentPerMonths?.value === '' ? 0 : rentPerMonths?.value || formData?.month || 0
        let dayValue = rentPerMonths?.dayvalue === '' ? 0 : rentPerMonths?.dayvalue || formData?.days || 0
        let advanceAmount = (rentPerMonth * monthValue) + (dayValue * rentPerDay)
        setFormData((prev) => ({
            ...prev,
            advanceRent: advanceAmount,
        }));
    }
    const handleadvanceChange = (e) => {
        const { name, value } = e.target;
        if (name === 'month') {
            setFormData((prev) => ({
                ...prev,
                month: value,
            }));

            advanceRentCalculation({ value })
        } else if (name === 'days') {
            let dayvalue = value
            setFormData((prev) => ({
                ...prev,
                days: value,
            }));
            advanceRentCalculation({ dayvalue })
        }
    }
    const handleSave = async () => {
        try {
            setloader(true);
            const currentDatetimeUTC = new Date().toISOString();
            if (!tenantDetails?.tanent1?.value) {
                toast.warning("Please Select Primary Tanent")
                setloader(false);
                return
                // } else if (!tenantDetails?.broker?.label) {
                //     toast.warning("Please Select Broker")
                //     setloader(false);
                //     return
            } else if (!tenantDetails?.prpManager?.label) {
                toast.warning("Please Select prpManager")
                setloader(false);
                return
            } else if (!tenantDetails?.type?.label) {
                toast.warning("Please Select type")
                setloader(false);
                return
            } else if (!tenantDetails?.agent?.label) {
                toast.warning("Please Select agent")
                setloader(false);
                return
            } else if (!entries?.[0]?.Property?.label) {
                toast.warning("Please Select Units ")
                setloader(false);
                return
            }
            let hasInvalidUnit = false;

            // Validate all entries first
            for (const item of entries) {
                const params = new URLSearchParams();
                params.append('Action', 'CheckUnitAvbSaveValidation');
                params.append('UnitNo', item?.Unit?.label);
                params.append('PropertyNo', item?.Property?.value);

                const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);

                if (res?.data?.result?.data?.cnt > 0) {
                    toast.warning(`Selected Unit ${item?.Unit?.label} Already Existed, in Given ${item?.periodFrom} to ${item?.periodto}`);
                    hasInvalidUnit = true;
                }
            }

            // If any unit was invalid, stop here
            if (hasInvalidUnit) {
                setloader(false);
                return;
            }

            // Helper function for month diff

            // Build lease reservation list
            const leaseReservationMasterlst = entries.map((item, index) => {
                const leaseTermInMonths = getMonthDiff(item?.periodFrom, item?.periodto);
                return {
                    leaseNo: leaseData?.lease_No || leaseData?.leaseNo,
                    group_Id: leaseData?.group_Id || leaseData?.groupId,
                    recordId: leaseda?.Record_Id,
                    cust1_No: tenantDetails?.tanent1?.value || "0",
                    cust1_Name: tenantDetails?.tanent1?.label || "0",
                    cust2_No: tenantDetails?.tanent2?.value || "0",
                    cust2_Name: tenantDetails?.tanent2?.label || "0",
                    custPri_ContactNo: tenantDetails?.tanent1Code?.value?.MainContactno || "0",
                    custPri_Email: tenantDetails?.tanent1Code?.value?.Email_id || "0",
                    custPri_PassportID: "0",
                    custPri_Nationality: tenantDetails?.tanent1Code?.value?.Nationality || "0",
                    custPri_VatRegNo: "0",
                    custJoint_CustNo: tenantDetails?.tanent2Code?.value?.Customer_no || "0",
                    custJoint_CustName: tenantDetails?.tanent2Code?.value?.Customer_Name || "0",
                    custJoint_ContactNo: tenantDetails?.tanent2Code?.value?.MainContactno || "0",
                    custJoint_Email: tenantDetails?.tanent2Code?.value?.Email_id || "0",
                    custJoint_PassportID: "0",
                    custJoint_Nationality: tenantDetails?.tanent2Code?.value?.Nationality || "0",
                    custJoint_VatRegNo: "0",
                    // Agent Passes in Sale Person
                    salesPerson: tenantDetails?.agent?.label,
                    // Broker Passes in Agent
                    agent: tenantDetails?.broker?.label || "0",
                    tenantMoveType: tenantDetails?.type?.label,
                    propManager: tenantDetails?.prpManager?.label,
                    package: tenantDetails?.package?.label,
                    rentPerAnnum: item?.Rent_Per_Annum.toString(),
                    leasing_Fee: item?.Tenant_Commission.toString(),
                    service_Charge: item?.serviceCharges.toString() || "0",
                    // Rent free amount in advance
                    advance: item?.rentFree.toString(),
                    security_Deposit: item?.Security_Deposit.toString(),
                    misc_Charges: "0",
                    dewa: "0",
                    shopFit_Deposit: item?.Parking_Price.toString(),
                    leaseTerm: item?.leaseTerm,
                    leaseTermInMonths: leaseTermInMonths?.toString(),
                    rentPaymentTerm: "0",
                    paymentTermNoOfChqs: leaseTermInMonths,
                    // date
                    rentCommencementDate: moment(item?.periodFrom).format("DD-MMM-YYYY"),
                    shopFitPeriod: "0",
                    anticipatedPremisesHandoverDate: "0",
                    anticipatedOpeningDate: "0",
                    status: "Lease Reserved",
                    pay_Option: "Group",
                    serviceChargeIncrease_Remarks: "0",
                    advHandoverNotice: "0",
                    handoverNotice: "0",
                    premisesHandoverDate: "0",
                    advNoticeOpening: "0",
                    mallOpeningDate: "0",
                    longStopDate: "0",
                    insurancePolicy: "0",
                    insuredAmount: "0",
                    addendum: "0",
                    rentPI: item?.Rent_Per_Annum.toString(),
                    rentPI_Years: item?.Rent_Month.toString(),
                    remarks: item?.reservation === "Lease Agreement Remarks" ? "0" : item?.remarks2 || "0",
                    rentPI_Remarks: item?.reservation === "Lease Agreement Remarks" ? item?.remarks2.toString() : "0",
                    tenantManual: "0",
                    tenantManualDate: "01-Jan-1900",
                    franchiseAgreement: "0",
                    franchiseExpDate: "01-Jan-1900",
                    franchiseRemarks: "0",
                    districtCooling: "0",
                    portableWater: tenantDetails?.type?.label,
                    totalArea: item?.Total_Area.toString(),
                    totalPrice: item?.Rent_Per_period.toString(),
                    totalPriceByUser: item?.Rent_Per_period.toString(),
                    exp1: item?.Landlord,
                    exp2: "0",
                    exp3: "0",
                    exp4: moment(item?.transDate).format("DD-MMM-YYYY"),
                    exp5: "0",
                    exp6: "0",
                    exp7: item?.Unit_Class,
                    exp8: item?.Ref_No,
                    exp9: item?.Rent_Per_Annum.toString(),
                    exp10: "Long Term",
                    exp11: item?.electricty || "0",
                    // Rent per month taxtbox value
                    exp12: item?.Rent_Per_Month.toString(),
                    exp13: item?.advanceRent.toString(),
                    exp14: item?.month?.toString(),
                    // Variable Charges
                    exp15: "0",
                    exp16: tenantDetails?.prpManager?.label,
                    // exp17: tenantDetails?.package?.label,
                    exp17: item?.electrictType === "Inclusive" ? "1" : "0" || "0",
                    exp18: item?.internet === true ? "1" : "0" || "0",
                    exp19: item?.term || "0",
                    // Days Dropdown 
                    exp20: item?.days?.toString() || "0",
                    modified_By: userName,
                    modified_On: currentDatetimeUTC,
                    seriesNo: "0",
                    discountPercent: "0",
                    discount: "0",
                    taxCode: "0",
                    taxInclusive: "0",
                    vatPercent: "0",
                    stPercent: "0",
                    st: "0",
                    vat: "0",
                    rent: item?.Rent_Per_period?.toString(),
                    total: item?.Rent_Per_period?.toString(),
                    propertyNo: item?.Property?.value,
                    propertyName: item?.Property?.label,
                    unitNo: item?.Unit?.label,
                    unitRefNo: item?.Ref_No,
                    unitClass: item?.Unit_Class,
                    taxPercent: "0",
                    landlord: item?.Landlord,
                    municipalityNo: item?.MuncAcNo,
                    lease_Date: moment(item?.periodFrom).format("DD-MMM-YYYY"),
                    lease_Expiry: moment(item?.periodto).format("DD-MMM-YYYY"),
                    category_Mix: "0",
                    property_Id: item?.Property?.value,
                    financialPosting: false,
                    groupPayment: true,
                    groupLeaseNo: true,
                    psOtherPayment: true,
                    installmentInvoice: false,
                    otherPaymentInvoice: true
                };
            });

            const body = {
                leaseReservationMain: {
                    leaseReservationMasterlst,
                    validateMeassage: datamsg
                }
            };
            const postRes = await apiService.post('GET_RESERV_CREATE', body);
            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
                if (postRes?.data?.result?.leaseNo && postRes?.data?.result?.groupId) {
                    toast.success(`${postRes?.data?.result?.leaseNo} Created successfully`);
                    setloader(false);
                    navigate('/Lease/Management/Lease/Reservation')
                } else {
                    toast.warning(postRes?.data?.message)
                    setloader(false);
                }
            } else {
                toast.warning(`${postRes?.data?.message}`);
                setloader(false);
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
        } finally {
            setloader(false);
        }
    };
    const handleBackClick = () => {
        window.history.back();
    };
    const loadOptions = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant?.text, label: tenant.value })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    };
    const loadOptionsName = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant?.value, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    };
    // Customer
    const handleCountryChange = async (selectedOption) => {
        const params = new URLSearchParams();
        params.append('DropdownFor', 'CustCityDescByCountry');
        params.append('CascadText', selectedOption?.label);
        const res = await apiService.getApiParamater('CUSTOMER_CASCAD', `?${params.toString()}`);
        setCityList(res?.data?.items)
        setSelectedCountry(selectedOption);
        setSelectedCity(null);
    }
    const handleSaveCustomer = async () => {
        try {
            setTableLoading(true);
            const currentDatetimeUTC = new Date().toISOString();
            for (const rule of validationRules) {
                if (!transectionData?.[rule.key]) {
                    setTableLoading(false);
                    toast.warning(rule.message);
                    return;
                }
            }
            if (!/^\S+@\S+\.\S+$/.test(transectionData.email)) {
                setTableLoading(false);
                toast.warning("Please Enter Valid Email");
                return;
            }
            let fullName = (transectionData?.firstName + " " + transectionData?.lastName)
            const validParam = new URLSearchParams();
            validParam.append('Action', 'CheckPrimaryContact');
            validParam.append('TenantNo', '0');
            validParam.append('TenantName', fullName);
            validParam.append('CustomerType', transectionData?.countryCode?.dialCode);
            validParam.append('UnitRefNo', transectionData?.mobileNo);
            const validRes = await apiService.getApiParamater('CUSTOMER_COMMON', `?${validParam.toString()}`);
            const value = Object.values(validRes?.result?.data || {})[0];
            if (value) {
                setTableLoading(false);
                toast.warning("User with this name already exists");
                return;
            }
            const countryCode = transectionData?.countryCode?.dialCode?.toString() || "";

            const phoneWithoutCode = transectionData?.mobileNo?.toString().startsWith(countryCode)
                ? transectionData.mobileNo.toString().slice(countryCode.length)
                : transectionData.mobileNo;
            let customerMaster = {
                record_id: 0,
                customertype: transectionData.type?.label || "",
                customer_no: "0",
                title: transectionData.title?.label,
                customer_Name: fullName || "",
                poBox: transectionData.poBox || "",
                mainaddress1: transectionData.address,
                mainaddress2: "0",
                maincountry: selectedCountry?.label || "",
                maincity: selectedCity?.label || "",
                mainContactno: phoneWithoutCode || "0",
                nationality: transectionData.nationality?.label || "0",
                source: transectionData.source?.label || "0",
                salesPerson: transectionData.salesPerson?.label || "0",
                agent: transectionData.agent?.label || "0",
                remarks: "0",
                tradeLicNo: "0",
                tL_issue_date: "01-jan-1900",
                tL_Expiry_date: "01-jan-1900",
                permitted_Use: "0",
                category_Mix: transectionData?.categoryMix?.label || "0",
                contactPerson: "0",
                contactPersonNo: "0",
                email_id: transectionData.email || "0",
                occupation: transectionData?.firstName || "0",
                contactaddress: transectionData?.designation || "0",
                designation: "0",
                department: transectionData?.lastName || "0",
                cpNationality: transectionData.nationality?.label || "",
                cdate: transectionData.dateofBirth || "01-jan-1900",
                status: "Active",
                exp1: transectionData.firstNameAR || "",
                exp2: transectionData.lastNameAR || "",
                exp3: currentDatetimeUTC,
                modify_by: userName || "",
                modify_on: currentDatetimeUTC,
                createdBy: userName || "",
                createdOn: currentDatetimeUTC,
                accountCode: "0",
                accountName: "0",
                sgCode: "0",
                exp4: transectionData?.leadtype?.label || "0",
                exp5: transectionData?.subsource?.label || "0",
                exp6: ("+" + transectionData?.countryCode?.dialCode) || "0",
                exp7: "0",
                exp8: transectionData?.companyName || fullName || "0",
                exp9: transectionData?.addressAR || "0",
                exp10: "0",
                exp11: "0",
                exp12: "0",
                exp13: "0",
                exp14: transectionData?.gender?.label || "0",
                exp15: "0",
                exp16: transectionData?.productType?.label || "0",
                exp17: "0",
                vatRegNo: "0",
                taxCode: 0,
                leadtype: transectionData.leadtype?.label || "0"
            }
            const additionalContatList = [{
                cd_id: 0,
                customer_id: "0",
                contact_type: "0",
                country_code: "0",
                area_code: "0",
                contact_no: "0",
                contactPersonBI: "0"
            }]
            const activityLists = [{
                recordId: 0,
                activityId: 0,
                leadId: "0",
                customerNo: "0",
                customerName: "0",
                activityType: "0",
                activityPurpose: "0",
                activityFromDate: "2025-12-21T05:52:41.499Z",
                activityToDate: "2025-12-21T05:52:41.499Z",
                description: "0",
                status: "0",
                priority: "0",
                assignedTo: "0",
                remarks: "0",
                exp1: "0",
                exp2: "0",
                exp3: "0",
                exp4: "0",
                exp5: "0",
                createdBy: userName || "0",
                createdOn: currentDatetimeUTC,
                modifiedBy: userName || "0",
                modifiedOn: currentDatetimeUTC
            }]
            const customerDocumetsList = [{
                customer_No: "0",
                document_Type: "0",
                document_No: "0",
                document_Desc: "0",
                doc_IssueDate: "0",
                doc_ExpiryDate: "0",
                document_Path: "0"
            }]
            const preferencesList = [{
                recordId: 0,
                leadId: "0",
                customerNo: "0",
                interest: "0",
                community: "0",
                location: "0",
                property: "0",
                unit: "0",
                unitType: "0",
                unitView: "0",
                floor: "0",
                bedrooms: "0",
                budgetFrom: "0",
                budgetTo: "0",
                unitArea: "0",
                exp1: "0",
                exp2: "0",
                exp3: "0",
                exp4: "0",
                exp5: "0",
                createdBy: userName || "0",
                createdOn: currentDatetimeUTC,
                modifiedBy: userName || "0",
                modifiedOn: currentDatetimeUTC
            }]
            const additionalAddressList = [{
                cD_ID: "0",
                customeR_ID: "0",
                addresS_TYPE_ID: "0",
                pobox: "0",
                linE1: "0",
                linE2: "0",
                linE3: "0",
                countrY_CODE: "0",
                citY_CODE: "0"
            }]
            const getSearchCustomerList = [
                {
                    recordId: 0,
                    customerNo: "0",
                    accountCode: "0",
                    customerType: transectionData?.type?.label || "0",
                    customerName: userName || "0",
                    contactNo: transectionData?.phoneNo || "0",
                    emailId: transectionData?.email || "0",
                    salesPerson: transectionData?.salesPerson?.label || "0",
                    source: transectionData?.source?.label || "0",
                    nationality: transectionData?.nationality?.label || "0",
                    agent: transectionData?.agent?.label || "0",
                    city: selectedCity?.label || "0",
                    country: selectedCountry?.label || "0",
                    createdBy: userName || "0",
                    createdOn: currentDatetimeUTC,
                    modifiedBy: userName || "0",
                    modifiedOn: currentDatetimeUTC
                }
            ]
            const body = {
                customerMain: {
                    customerMaster: customerMaster,
                    additionalContatList: additionalContatList,
                    activityList: activityLists,
                    customerDocumetsList: customerDocumetsList,
                    preferencesList: preferencesList,
                    additionalAddressList: additionalAddressList,
                    getSearchCustomerList: getSearchCustomerList,
                    createLedger: false,
                    custNo: "0",
                    rblExpiredDocs: "0"
                }
            };
            const postRes = await apiService.post('POST_CUSTOMER', body);
            if (postRes?.data?.statusCode === 201) {
                toast.success(postRes?.data?.message);
                const params = new URLSearchParams();
                params.append('dropdownTypes', 'ReservationTenantNames');
                const customerRes = await apiService.getApiParamater('GET_MULTI_DROP_RESERV', `?${params.toString()}`);
                setTanentList(customerRes?.data?.dropdowns?.TenantNames);
                setTransectionData({
                    salesPerson: '',
                    type: '',
                    mobileNo: '',
                    agent: '',
                    fullName: '',
                    title: '',
                    email: '',
                    firstName: '',
                    gender: '',
                    lastName: '',
                    phoneNo: '',
                    poBox: '',
                    categoryMix: '',
                    salesPerson: '',
                    address: '',
                    dateofBirth: '',
                    firstNameAR: '',
                    lastNameAR: '',
                    addressAR: '',
                    source: '',
                    designatoin: '',
                    subsource: '',
                    leadtype: '',
                    countryCode: '',
                    companyName: '',
                    designation: '',
                    nationality: null,
                    productType: null,
                });
                setTableLoading(false);
                setTenantModal(false)
            } else {
                toast.warning(`${postRes?.data?.message}`);
                setTableLoading(false);
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setTableLoading(false);
        } finally {
            setTableLoading(false);
        }
    }

    return (
        <div className="p-3">
            <div className='mb-3'><h6>Lease Reservation</h6></div>
            <div className='d-flex justify-content-between border-box2 p-3' style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills start overslid d-flex gap-4'>
                    <div
                        className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}
                    >
                        Tenant Details
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        Unit Details
                    </div>
                </div>
                <div className='d-flex gap-1'>
                    {loading === true ?
                        <div className='mainbtn flex-end gap-2 w-50'>
                            <ClipLoader color="#ffffff" className='mt-1' size={25} />
                        </div>
                        :
                        <div className='mainbtn flex-end gap-2 w-50' onClick={handleSave}>
                            <FaSave color='#fff' className='center mt-2 mx-2' />
                            <div className='center'>Save</div>
                        </div>
                    }
                    <div className='mainbtnRed flex-end gap-2 w-50'>
                        <RiRefreshLine color='#fff' className='center mt-2 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                    <div className='mainbtnSecondary flex-end gap-2 w-50' onClick={handleBackClick}>
                        <FaChevronLeft color='#fff' className='center mt-2 mx-2' />
                        <div className='center'>Back</div>
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <div className=''>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}>
                            <div className='param-label pt-1 col-2'>Tenant Primary Details</div>
                            <IoIosArrowForward
                                size={30}
                                className={`arrow fade-rotate ${FilterTab ? "open" : ""}`}
                            />
                        </div>
                        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                                {barload === true ?
                                    <div className='center p-5'>
                                        <PropagateLoader color="#6E5199" />
                                    </div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex justify-content-between gap-1">
                                            <div className="d-flex" style={{ width: '100%' }}>
                                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant Name</label>
                                                <AsyncPaginate
                                                    className="p-0 w-100"
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                        option: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                                            color: "#000",
                                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                                        }),
                                                    }}
                                                    loadOptions={loadOptionsName}
                                                    value={tenantDetails?.tanent1}
                                                    onChange={(selectedOption) => handleCust1Change(selectedOption)}
                                                    additional={{ page: 0 }}
                                                />
                                            </div>
                                            <button className="mainbtn center ms-2 px-2" onClick={() => setTenantModal(true)}>
                                                <MdAdd color="#fff" size={22} />
                                            </button>
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant No</label>
                                            <AsyncPaginate
                                                className="p-0 w-50"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                                        color: "#000",
                                                        ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                                    }),
                                                }}
                                                loadOptions={loadOptions}
                                                value={tenantDetails.tanent1Code}
                                                onChange={(selectedOption) => handleCust1CodeChange(selectedOption)}
                                                additional={{ page: 0 }}
                                            />
                                            <div className='text-warning px-2 center' style={{ color: "#ffd24b", fontSize: "14px", fontWeight: "500" }}>{tenantDetails?.tanent1Code?.value?.Category_Mix || "---"}</div>

                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                            <input type="text" className="p-2 form-control w-75" name="periodto" value={tenantDetails?.tanent1Code?.value?.MainContactno} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                            <input type="email" className="p-2 form-control w-75" value={tenantDetails?.tanent1Code?.value?.Email_id} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Trade Lic</label>
                                            <input type="text" className="p-2 form-control w-75" name="installments" value={tenantDetails?.tanent1Code?.value?.TradeLicNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={tenantDetails?.tanent1Code?.value?.Nationality} readOnly />

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setAgentTab(!AgentTab)}>
                            <div className='param-label pt-1 col-2'>Tenant Secondary Details</div>
                            <IoIosArrowForward
                                size={30}
                                className={`arrow fade-rotate ${AgentTab ? "open" : ""}`}
                            />
                        </div>
                        <div className={`slide-content ${AgentTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${AgentTab ? 'slide-in' : 'slide-out'}`}>
                                {barload === true ?
                                    <div className='center p-5'>
                                        <PropagateLoader color="#6E5199" />
                                    </div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant Name</label>
                                            <AsyncPaginate
                                                className="p-0 w-100"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                                        color: "#000",
                                                        ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                                    }),
                                                }}
                                                value={tenantDetails?.tanent2}
                                                loadOptions={loadOptionsName}
                                                onChange={(selectedOption) => handleCust2Change(selectedOption)}
                                                additional={{ page: 0 }}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant No</label>
                                            <AsyncPaginate
                                                className="p-0 w-100"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                                        color: "#000",
                                                        ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                                    }),
                                                }}
                                                loadOptions={loadOptions}
                                                value={tenantDetails.tanent2Code}
                                                onChange={(selectedOption) => handleCust2CodeChange(selectedOption)}
                                                additional={{ page: 0 }}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                            <input type="text" className="p-2 form-control w-75" name="periodto" value={tenantDetails?.tanent2Code?.value?.MainContactno} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                            <input type="email" className="p-2 form-control w-75" value={tenantDetails?.tanent2Code?.value?.Email_id} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Trade Lic</label>
                                            <input type="text" className="p-2 form-control w-75" name="installments" value={tenantDetails?.tanent2Code?.value?.TradeLicNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={tenantDetails?.tanent2Code?.value?.Nationality} readOnly />

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setSecondaryTab(!SecondaryTab)}>
                            <div className='param-label pt-1 col-2'>Lease Agent Details</div>
                            <IoIosArrowForward
                                size={30}
                                className={`arrow fade-rotate ${SecondaryTab ? "open" : ""}`}
                            />
                        </div>
                        <div className={`slide-content ${SecondaryTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${SecondaryTab ? 'slide-in' : 'slide-out'}`}>
                                {barload === true ?
                                    <div className='center p-5'>
                                        <PropagateLoader color="#6E5199" />
                                    </div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Leaseing Agent</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={tenantDetails?.agent}
                                                options={AgentList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                                onChange={(selectedOption) => handleAgentChange(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Prp Manager</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={tenantDetails?.prpManager}
                                                options={ManagerList?.map((cost) => ({ value: cost, label: cost?.text }))}
                                                onChange={(selectedOption) => handleManagerChange(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Broker</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                isClearable
                                                value={tenantDetails?.broker}
                                                options={BrokerList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                                onChange={(selectedOption) => handleBrokerChange(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Package</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={tenantDetails?.package}
                                                options={PackageList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                                onChange={(selectedOption) => handlePackageChange(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Type</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={tenantDetails?.type}
                                                options={TypeList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                                onChange={(selectedOption) => handleTypeChange(selectedOption)}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {gridVisibility[1] && (
                <div className="cost-center-section my-3">
                    <div className="d-flex cursor-pointer slide-header"
                        onClick={() => setUnitRent(!unitRent)}>
                        <div className='param-label pt-1 col-2'>Unit Rent Details</div>
                        <IoIosArrowForward
                            size={30}
                            className={`arrow fade-rotate ${unitRent ? "open" : ""}`}
                        />
                    </div>
                    <div className={`slide-content ${unitRent ? 'open' : 'closed'}`}>
                        <div className={`border-box2 p-3 ${unitRent ? 'slide-in' : 'slide-out'}`}>
                            <div className="form-group grid-contain ">
                                {/* PropertNo */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Property</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={formData.Property}
                                        options={propertyList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                        onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                    />
                                </div>
                                <div className="d-flex gap-3">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Unit Ref No</label>
                                    <input type="text" className="p-2 form-control w-75" name="bedRooms"
                                        value={formData.Ref_No} disabled />
                                    <div className='text-bold center text-warning'>{formData?.Unit_Class}</div>
                                </div>

                                <div className="d-flex gap-3 justify-content-between" >
                                    <div className='gap-3 d-flex center'>
                                        {["Inclusive", "Exclusive"].map((label) => (
                                            <div className="form-check" key={label}>
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    name="electrictType"
                                                    value={label}
                                                    checked={formData.electrictType === label}
                                                    onChange={handleElectChange}
                                                />
                                                <label className="form-check-label">{label}</label>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='gap-3 center '>
                                        <input className="form-check-input"
                                            type="checkbox"
                                            id="internet" style={{ width: "20px", height: "20px" }}
                                            name="internet"
                                            disabled={formData?.electrictType === "Inclusive"}
                                            checked={formData?.internet}
                                            onChange={(e) => handleInterNetChange(e.target.checked)}
                                        />
                                        <label className='px-2'>Internet</label>
                                    </div>
                                </div>
                                {/* UnitNo */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Unit No *</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={formData.Unit}
                                        options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                        onChange={(selectedOption) => handleUnitChange(selectedOption)}
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent for Period</label>
                                    <input type="number" className="p-2 form-control w-75" name="Rent_Per_period" disabled
                                        value={Number(formData.Rent_Per_period)?.toFixed(currencyPrecision?.decimalNumbers)} onChange={handleChange} />
                                </div>
                                <div className="d-flex gap-3">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Electrical Consumption</label>
                                    <input type="number" className="p-2 form-control w-75" name="electricty"
                                        value={formData.electricty} onChange={handleChange} />
                                    <div className='center text-bold text-primary'>{(formData?.Rent_Per_Annum || 0)?.toFixed(currencyPrecision?.decimalNumbers)}</div>
                                </div>
                                {/* Total Area */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Total Area</label>
                                    <input type="text" className="p-2 form-control w-75" name="noCommunity"
                                        value={formData.Total_Area} disabled />
                                </div>
                                {/* terms */}
                                <div className="d-flex gap-3 mb-3">
                                    {["Short Term", "Long Term", "Less than one Year"].map((label) => (
                                        <div className="form-check" key={label}>
                                            <input
                                                type="radio"
                                                className="form-check-input"
                                                name="term"
                                                value={label}
                                                // disabled={label === "Short Term"}
                                                checked={formData.term === label}
                                                onChange={handleTermChange}
                                            />
                                            <label className="form-check-label">{label}</label>
                                        </div>
                                    ))}
                                </div>
                                <div className="d-flex gap-3">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent/Month</label>
                                    <input
                                        type="number"
                                        className="p-2 form-control w-75"
                                        name="Rent_Per_Month"
                                        value={formData.Rent_Per_Month}
                                        // min={Number(formData?.Rent_Month || 0)}
                                        onChange={handleChange}
                                    // onBlur={(e) => {
                                    //     const minRent = Number(formData?.Rent_Month || 0);

                                    //     if (Number(e.target.value) < minRent) {
                                    //         setFormData((prev) => ({
                                    //             ...prev,
                                    //             Rent_Per_Month: minRent,
                                    //         }));
                                    //     }
                                    // }}
                                    />
                                    <div className='center text-primary'>{(formData?.Rent_Month || 0)?.toFixed(currencyPrecision?.decimalNumbers)}</div>
                                </div>
                                {/* advance rend */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Bedroom(s)</label>
                                    <input type="email" className="p-2 form-control w-75" name="Bedrooms"
                                        value={formData.Bedrooms} disabled />
                                </div>
                                {/* transdate */}
                                <div className="d-flex">
                                    <label className="form-label pt-1 text-danger">TransDate</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={formData?.transDate}
                                        onChange={(date) => handleDateChange({ name: 'transDate', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Security Deposit</label>
                                    <input type="number" className="p-2 form-control w-75" name="Security_Deposit"
                                        value={formData.Security_Deposit} onChange={handleChange} />
                                </div>
                                {/*  */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Parking</label>
                                    <input type="text" className="p-2 form-control w-75" name="Parking"
                                        value={formData.Parking} readOnly />
                                </div>
                                {/* period from */}
                                <div className="d-flex mb-2">
                                    <label className="form-label pt-1 start">Period From</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={formData.periodFrom ? new Date(formData.periodFrom) : null}
                                        onChange={(date) => handleDateChange({ name: 'periodFrom', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100 datepicker-icon"
                                        disabled={!datesEditable}
                                    />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Service Charges</label>
                                    <input type="number" className="p-2 form-control w-100" name="serviceCharges"
                                        value={formData.serviceCharges} disabled onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">LandLoard</label>
                                    <input type="text" className="p-2 form-control w-75" name="Landlord"
                                        value={formData.Landlord} disabled onChange={handleChange} />
                                </div>
                                {/* period to */}
                                <div className="d-flex mb-2">
                                    <label className="form-label pt-1 start">Period To</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={formData.periodto ? new Date(formData.periodto) : null}
                                        onChange={(date) => handleDateChange({ name: 'periodto', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100 datepicker-icon"
                                        disabled={!datesEditable}
                                    />
                                </div>

                                <div className="d-flex gap-2">
                                    <label className="form-label pt-1">Advance Rent</label>
                                    <input
                                        type="number"
                                        className="p-2 form-control w-25"
                                        name="advanceRent"
                                        value={Number(formData.advanceRent)?.toFixed(currencyPrecision?.decimalNumbers)}
                                        disabled
                                    />
                                    <select
                                        className="p-2 form-control w-25"
                                        value={formData.month}
                                        name='month'
                                        onChange={handleadvanceChange}
                                    >
                                        <option value="">Select Month</option>
                                        {[...Array(12)].map((_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        className="p-2 form-control w-25"
                                        value={formData.days}
                                        name='days'
                                        onChange={handleadvanceChange}
                                    >
                                        <option value="">Select Days</option>
                                        {[...Array(31)].map((_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Munc A/C No</label>
                                    <input type="text" className="p-2 form-control w-75" name="MuncAcNo"
                                        value={formData.MuncAcNo} disabled onChange={handleChange} />
                                </div>
                                {/* lease term */}
                                <div className="d-flex mb-2">
                                    <label className="form-label pt-1 start">Lease Term</label>
                                    <input
                                        type="text"
                                        className="p-2 form-control w-75"
                                        name="leaseTerm"
                                        value={formData.leaseTerm}
                                        readOnly
                                    />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Total Advance Payment</label>
                                    <input type="number" className="p-2 form-control w-75" name="Security_Deposit" disabled
                                        value={(Number(formData.advanceRent || 0) + Number(formData.Security_Deposit || 0)).toFixed(currencyPrecision?.decimalNumbers)} />
                                </div>
                                {/* rent free */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent Free Amount</label>
                                    <input type="number" min="0" className="p-2 form-control w-75" name="rentFree"
                                        value={formData.rentFree} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Reservation/ Agreement</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-100 p-0"
                                        value={formData.reservation}
                                        options={remarksList?.map((cost) => ({ value: cost, label: cost?.value }))}
                                        onChange={(selectedOption) => handleRemarksChange(selectedOption)}
                                    />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Parking Charges</label>
                                    <input type="number" className="p-2 form-control w-75" name="Parking_Price"
                                        value={formData.Parking_Price} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    <textarea type="number" className="form-control" name="remarks2"
                                        value={formData.remarks2} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    <textarea type="number" className="form-control" name="remarks1"
                                        value={formData.remarks1} onChange={handleChange} placeholder='Narration' />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Leaseing Commission</label>
                                    <input type="number" className="p-2 form-control w-75" name="Tenant_Commission"
                                        value={formData.Tenant_Commission} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    {editIndex !== null ?
                                        <button className="btn btn-primary my-3" onClick={handleUpdate}>
                                            Update
                                        </button> :
                                        <button className="btn btn-primary my-3" onClick={handleAddMore}>
                                            Add
                                        </button>
                                    }
                                </div>
                                <div></div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Admin/Leasing Fee</label>
                                    <input type="number" className="p-2 form-control w-75" name="leaseFee"
                                        value={formData.leaseFee} onChange={handleChange} />
                                </div>
                            </div>
                        </div>
                        <div className=" table-container  mt-4" style={{ overflowX: 'auto', height: "400px" }}>
                            <table>
                                <thead className='dynoTable p-0 m-0' >
                                    <tr>
                                        <th>Actions</th>
                                        <th>Property</th>
                                        <th>Unit</th>
                                        <th>Total Area</th>
                                        <th>Trans Date</th>
                                        <th>Period From</th>
                                        <th>Period To</th>
                                        <th>Rent for Period</th>
                                        <th>Security Deposit</th>
                                        <th>Ejari Charges</th>
                                        <th>Service Charges</th>
                                        <th>Parking Price</th>
                                        <th>Admin Fee</th>
                                        <th>Rent Free Amount</th>
                                        <th>No of Installments</th>
                                        <th>Lease Term</th>
                                        <th>Reservation/ Agreement</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody className='p-0 m-0'>
                                    {entries?.map((entry, index) => (
                                        <tr key={index} className='p-0 m-0'>
                                            <td className='gap-3 d-flex'>
                                                {!entry.Property?.label ?
                                                    <input className="p-1" disabled style={{ width: "80px" }} /> :
                                                    <>
                                                        <div className='pt-2' onClick={() => handleDelete(index)}>
                                                            <MdDelete size={25} />
                                                        </div>
                                                        <div className='pt-2' onClick={() => handleEdit(index)}>
                                                            <FiEdit size={25} />
                                                        </div>
                                                    </>
                                                }
                                            </td>
                                            <td className='m-0 p-0'><input className="p-1" value={entry.Property?.label} disabled style={{ width: "150px" }} /></td>
                                            <td><input className="p-1" value={entry.Unit?.label} disabled style={{ width: "100px" }} /></td>
                                            <td><input className="p-1" value={entry.Total_Area} disabled style={{ width: "110px" }} /></td>
                                            <td><input className="p-1" value={moment(entry.transDate || currentdate).format("DD-MMM-YYYY")} disabled style={{ width: "115px" }} /></td>
                                            <td><input className="p-1" value={moment(entry.periodFrom || currentdate).format("DD-MMM-YYYY")} disabled style={{ width: "115px" }} /></td>
                                            <td><input className="p-1" value={moment(entry.periodto || currentdate).format("DD-MMM-YYYY")} disabled style={{ width: "120px" }} /></td>
                                            <td><input className="p-1" value={Number(entry.Rent_Per_period)?.toFixed(currencyPrecision?.decimalNumbers)} disabled style={{ width: "140px" }} /></td>
                                            <td><input className="p-1" value={entry.Security_Deposit} disabled style={{ width: "140px" }} /></td>
                                            <td><input className="p-1" value={entry.ejari || ""} disabled style={{ width: "130px" }} /></td>
                                            <td><input className="p-1" value={entry.serviceCharges} disabled style={{ width: "140px" }} /></td>
                                            <td><input className="p-1" value={entry.Parking_Price} disabled style={{ width: "130px" }} /></td>
                                            <td><input className="p-1" value={entry.leaseFee} disabled style={{ width: "110px" }} /></td>
                                            <td><input className="p-1" value={entry.rentFree} disabled style={{ width: "150px" }} /></td>
                                            <td><input className="p-1" value={entry.Installments} disabled style={{ width: "150px" }} /></td>
                                            <td><input className="p-1" value={entry.leaseTerm} disabled style={{ width: "110px" }} /></td>
                                            <td><input className="p-1" value={entry.reservation?.label} disabled /></td>
                                            <td><input className="p-1" value={entry.remarks2} disabled style={{ width: "fit-content" }} /></td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            <Modal size="md"
                show={msgModal} onHide={() => setmsgModal(false)}
                backdrop="static"
                contentLabel='Confirmation Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>{datamsg}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        Do you want to add Unit
                    </div>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Close</button>
                    <button className='mainbtnRed' onClick={dataset}>Ok</button>
                </Modal.Footer>
            </Modal>
            <Modal show={tenantModal} size="xl" onHide={() => setTenantModal(false)} keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Tenant</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
                        <div className='nav nav-pills overslid d-flex gap-4'>
                            <div className={`dashitems sidebar-text center ${popActive === 0 ? 'sideActive' : ''}`}
                                onClick={() => handlePopClick(0)}>Personal Details
                            </div>
                        </div>
                    </div>

                    {popVisibility[0] && (<PersonalDetails tableLoading={tableLoading} nationalityList={nationalityList} countriesList={countriesList} cityList={cityList} handleCountryChange={handleCountryChange} sourceList={sourceList} customerTypeList={customerTypeList} salesPersonList={salesPersonList} selectedCity={selectedCity}
                        setTransectionData={setTransectionData} leadStatus={leadStatus} selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} setSelectedCity={setSelectedCity}
                        transectionData={transectionData} agentList={agentList} titleList={titleList} leadType={personalTabLeadType} categoryMix={categoryMix}
                        defaultCountry={defaultCountry} packageName={packageName} />)}
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex gap-3'>
                        {tableLoading === true ?
                            <div className='mainbtn flex-end gap-2 w-50'>
                                <ClipLoader color="#ffffff" className='mt-1' size={15} />
                            </div>
                            :
                            <button className="mainbtn ms-auto px-3" onClick={handleSaveCustomer}>Save</button>
                        }
                        <button className="mainbtnSecondary ms-auto px-3" onClick={() => setTenantModal(false)}>Close</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default LeaseReservationCreateByBashboard;
